<template>
  <v-container fluid>
    <v-btn
      color="red darken-3"
      class="ml-7 my-back-btn-style"
      text
      x-large
      dark
      @click="back()"
    >
      <v-icon
        left
        dark
      >
        mdi-arrow-left-bold
      </v-icon>
      Back
    </v-btn>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-monitor-star
      </v-icon>  Digi-Board Time Slot Prices
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <v-col
        cols="12"
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="assignProductCategory()"
        >
          Assign Category
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              dense
              label="Search"
              append-icon="mdi-magnify"
              outlined
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="digiBoardTimeSlotPrices"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>
              <font v-if="item.recurring_price===null">
                3 Years
              </font><font v-else>
                {{ item.recurring_price.interval_count }} {{ item.recurring_price.interval }}
              </font>
            </td>
            <td>{{ item.currency.toUpperCase() }} {{ item.amount | ConvertAmount }}</td>
            <td>{{ item.currency.toUpperCase() }} {{ item.display_price }}</td>
            <td>{{ item.type | pricingType }}</td>
            <td>{{ item.tax_behavior }}</td>
            <td>
              <font
                :color="getColor(item.active)"
                class="font-status-style"
              >
                {{ item.active | statusUpdate }}
              </font>
            </td>
          </tr>
        </template>
      </v-data-table>
      <br>
    </v-card>
    <br>
    <centre-spinner
      :loading="loading"
    />
    <assign-product-category
      v-if="showAssignCategoryForm"
      :digiboardtimeslotproductcategory="productCategoryDetails"
      @success="getPricesList"
      @closed="showAssignCategoryForm = false"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import moment from 'moment';
  import AssignProductCategory from './AssignProductCategory.vue';

  export default {
    name: 'DigiBoardTimeSlotPrices',
    components: {
      'centre-spinner': spinner,
      'assign-product-category': AssignProductCategory,
    },
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      statusUpdate (active) {
        if (active === true) {
          return 'Active*';
        } else {
          return 'Inactive';
        }
      },
      pricingType (pricingType) {
        if (pricingType === 'one_time') {
          return 'One-time';
        } else {
          return 'Recurring';
        }
      },
      ConvertAmount (amount) {
        return amount / 100;
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Pricing Name', align: 'start', value: 'name' },
          { text: 'Pricing Period', value: 'interval_count' },
          { text: 'Total Amount', value: 'amount' },
          { text: 'Monthly (For Display)', value: 'currency' },
          { text: 'Pricing Type', value: 'type' },
          { text: 'Tax Behavior', value: 'tax_behavior' },
          { text: 'Status', value: 'active' },
        ],
        showAssignCategoryForm: false,
        productCategoryDetails: {},
      };
    },
    computed: {
      digiBoardTimeSlotPrices () {
        const digiboardTimeSlotPrice = this.$store.getters['digiboards/getDigiBoardTmeSlotPrices'];
        if (Object.keys(digiboardTimeSlotPrice).length > 0) {
          const timeSlotPrices = digiboardTimeSlotPrice.prices;
          return timeSlotPrices;
        }
        return [];
      },
      digiBoardTimeSlotProCategory () {
        const digiboardTimeSlotPrice = this.$store.getters['digiboards/getDigiBoardTmeSlotPrices'];
        if (Object.keys(digiboardTimeSlotPrice).length > 0) {
          const productCategory = digiboardTimeSlotPrice;
          return productCategory;
        }
        return {};
      },
    },
    async mounted () {
      await this.getPricesList();
    },
    methods: {
      async getPricesList () {
        this.loading = true;
        const digiBoardTimeSlotId = this.$route.params.digiBoardTimeSlotId;
        await this.$store.dispatch('digiboards/fetchDigiBoardTimeSlotPrices', { digiBoardTimeSlotId: digiBoardTimeSlotId });
        this.loading = false;
      },
      getColor (status) {
        if (status === true) {
          return '#2E7D32';
        } else {
          return '#C62828';
        }
      },
      back () {
        const externalId = this.$route.params.externalid;
        this.$router.push(`/digi-boards/${externalId}`);
      },
      assignProductCategory () {
        this.productCategoryDetails = this.digiBoardTimeSlotProCategory;
        this.showAssignCategoryForm = true;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 10px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.font-my-style {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
}
.my-card-style {
    border-radius: 15px;
    background-color: #ECEFF1;
    margin-left: 20px;
}
.my-p-style {
    font-size: 16px;
    font-weight: bold;
    color: #546E7A;
    font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.v-data-table { background-color: #ECEFF1; }
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-status-style {
  font-weight: bold;
}
.price-header {
  color: #37474F;
  text-align: center;
}
.my-back-btn-style {
  margin-left: 0px !important;
}
@media (max-width: 960px) {
  .my-back-btn-style {
    margin-bottom: 0px;
    margin-left: 0px !important;
  }
}
</style>
